<div class="userContainer d-flex align-items-start"
     [ngClass]="{
    'current-student': remoteUser.accessType === AccessType.STUDENT,
    'userContainerClosed':
      remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.PENDING ||
      (remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.OFFLINE && !remoteUser.additionalInfo.isClassParticipant),
    'userContainerFullScreen':
        !remoteUser.additionalInfo.isInFullscreenMode &&
        remoteUser.accessType === AccessType.STUDENT &&
        remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE
  }">

  <div class="userControlsContainer d-flex align-items-center"
       *ngIf="
          !remoteUser.additionalInfo.isClassParticipant ||
          remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE;
        else
          offlineClassParticipant"
       [ngClass]="{'first-line': index < 6}">
    <div class="label-with-actions d-flex align-items-center"
         [ngClass]="remoteUser.accessType === AccessType.STUDENT ? 'label-with-actions-student' : 'label-with-actions'">
      <div class="userLabel text-truncate" *ngIf="remoteUser.accessType === AccessType.STUDENT">
        {{remoteUser.displayName}}
      </div>

      <div class="offline-student-score"
           *ngIf="remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.PENDING ||
                    remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.OFFLINE">
        {{remoteUser.additionalInfo.correctAnswersCount}}
      </div>

      <div class="d-flex align-items-center support-observer"
           *ngIf="remoteUser.accessType === AccessType.SUPPORT || remoteUser.accessType === AccessType.OBSERVER">
        <span
          [style.color]="(remoteUser | isSupportOrObserver) ? remoteUser.personalColor:
                            (remoteUser | isTeacher) ? '#0c97bf' : '#596682'"
          class="userLabel text-truncate">{{remoteUser | fullName}}</span>
        <span class="support-observer-icon fa-solid"
              title="{{remoteUser.accessType === AccessType.SUPPORT ? 'Support' : 'Observer'}}"
              [ngClass]="{'fa-headset' : remoteUser.accessType === AccessType.SUPPORT, 'fa-binoculars' : remoteUser.accessType === AccessType.OBSERVER}">
        </span>
      </div>

      <button type="submit" class="btn user-btn square" title="Expel Observer"
              *ngIf="remoteUser.accessType === AccessType.OBSERVER && localUser.accessType !== AccessType.OBSERVER"
              (click)="expelObserver()"><i class="fa fa-sign-out"></i></button>

      <app-user-action-panel
        *ngIf="remoteUser.accessType === AccessType.STUDENT && remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE"
        [remoteUser]="remoteUser"
        [userIndex]="index"
        [studentsCount]="studentsCount"
        [isOpenedFromList]="true">
      </app-user-action-panel>

      <app-sticker-button
        *ngIf="
          remoteUser.accessType === AccessType.STUDENT &&
          (localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER) &&
          remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE"
        [remoteUser]="remoteUser"
        [userIndex]="index"
        [studentsCount]=""
        [userListView]="true">
      </app-sticker-button>
      <button class="btn user-btn square fas fa-pencil-alt font-size-14"
              title="Toggle whiteboard sharing"

              *ngIf="
                  remoteUser.accessType === AccessType.STUDENT && localUser.accessType !== AccessType.OBSERVER &&
                  remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE"
              [ngStyle]="{'color': remoteUser.personalColor}"
              [disabled]="whiteboard.sharedUsers?.size === 0 || assignment.isLoaded"
              [class.on]="whiteboard.sharedUsers?.has(remoteUser.id) || whiteboard.sharedUsers?.size === 0"
              (click)="toggleWhiteboardSharing()">
      </button>
      <button class="btn user-btn square fa-solid fa-right-left font-size-14"
              title="Toggle assignment switch access"
              *ngIf="
                  remoteUser.accessType === AccessType.STUDENT && localUser.accessType !== AccessType.OBSERVER &&
                  remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE"
              [disabled]="!assignment.isLoaded || assignment.allowedSwitchingUsers?.size === 0"
              [class.on]="assignment.allowedSwitchingUsers?.has(remoteUser.id) || (assignment.allowedSwitchingUsers && assignment.allowedSwitchingUsers.size === 0)"
              (click)="toggleAssignmentSwitchAccessWith()">
      </button>
    </div>

    <button *ngIf="remoteUser.accessType !== AccessType.STUDENT"
            type="button" class="unanswered-message mr-2" style="color: #909090"
            title="{{remoteUser.additionalInfo.hasUnansweredMessage ? 'Unread message': 'No new messages'}}"
            [style]="localUser.accessType === AccessType.OBSERVER ? 'cursor: default !important' : ''"
            [ngClass]="{'active': remoteUser.additionalInfo.hasUnansweredMessage}"
            (click)="manuallyHideUnansweredMessageIcon()">
      <i class="fas fa-comment-dots"></i>
    </button>

    <div class="answerButtonsContainer d-flex align-items-center"
         *ngIf="
         (localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT ||
          localUser.accessType === AccessType.OBSERVER && remoteUser.accessType !== AccessType.STUDENT) &&
        remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE
      ">
      <button *ngIf="localUser.accessType !== AccessType.OBSERVER"
              class="btn user-btn far fa-comment-times doNotCloseChat  color-red "
              [ngClass]="{'limited-message': isChatLimitExceeded} "
              [title]="isChatLimitExceeded ? 'The student has reached the chat limit. Clear chat' : 'Clear chat'"
              style="font-size: 15px"
              title="Clear chat"
              (click)="clearIndividualChat()"></button>
      <input #inputValue type="text" class="chatInput form-control"
             (copy)="utilService.safeCopy($event)"
             (cut)="utilService.safeCut($event)"
             (paste)="utilService.safePaste($event)"
             (keyup.enter)="sendMessage(inputValue.value)">
      <button *ngIf="remoteUser.accessType === AccessType.STUDENT"
              class="btn user-btn fa fa-check doNotCloseChat color-green" title="Correct"
              (click)="correctAnswerScore()"></button>
      <button *ngIf="remoteUser.accessType === AccessType.STUDENT"
              class="btn user-btn fa fa-times doNotCloseChat color-red" title="Incorrect"
              (click)="incorrectAnswerScore()"></button>
      <span *ngIf="remoteUser.accessType === AccessType.STUDENT"
            class="correctCounter">{{remoteUser.additionalInfo.correctAnswersCount}}</span>
      <button *ngIf="remoteUser.accessType === AccessType.STUDENT"
              class="btn user-btn correctCounterReset" title="Reset counter" (click)="resetStudentScores()">
        <i class="far fa-undo-alt"></i>
      </button>
    </div>
  </div>

  <ng-template #offlineClassParticipant>
    <div class="userContainer">
      <div class="absent-user-element d-flex align-items-center">
        <div class="userLabel absentUserLabel text-truncate">{{remoteUser.displayName}}</div>

        <div class="offline-student-score"
             *ngIf="remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.PENDING ||
                    remoteUser.additionalInfo.roomConnectionStatus === RoomConnectionState.OFFLINE">
          {{remoteUser.additionalInfo.correctAnswersCount}}
        </div>

        <button type="button" class="reminder-email-button user-btn" title="Send reminder email"
                *ngIf="localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT"
                (click)="sendEmailToAbsentStudent()"><i class="fas fa-envelope"></i>
        </button>

        <div class="request-loader ml-2" *ngIf="sendReminderEmailStatus !== ReminderEmailStatus.NOT_TRIGGERED">
          <div class="spinner-border" *ngIf="sendReminderEmailStatus === ReminderEmailStatus.PENDING"></div>
          <i class="fas fa-check-circle request-success" title="Reminder email sent"
             *ngIf="sendReminderEmailStatus === ReminderEmailStatus.SUCCESS"></i>
          <i class="fas fa-exclamation-triangle request-failed" title="Unable to send reminder email"
             *ngIf="sendReminderEmailStatus === ReminderEmailStatus.ERROR"></i>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="briefLog-div ng-scope" *ngIf="remoteUser.additionalInfo.messages.length > 0">
    <div class="user-item-messages" [ngClass]="{'show': remoteUser.additionalInfo.isMessageBoxCollapsed}">
      <button *ngIf="localUser.accessType !== AccessType.OBSERVER &&
              remoteUser.additionalInfo.roomConnectionStatus !== RoomConnectionState.ONLINE"
              class="btn user-btn far fa-comment-times doNotCloseChat  color-red "
              [ngClass]="{'limited-message': isChatLimitExceeded} "
              [title]="isChatLimitExceeded ? 'The student has reached the chat limit. Clear chat' : 'Clear chat'"
              style="font-size: 15px"
              title="Clear chat"
              (click)="clearIndividualChat()">
      </button>
      <i *ngIf="
            remoteUser.additionalInfo.isMessageBoxCollapsed &&
            remoteUser.additionalInfo.doesMessageLengthExceededLimit"
         (click)="toggleShowMessages()"
         title="Expand chat"
         class="show-more-messages far fa-ellipsis-h ng-scope">
      </i>
      <span class="briefLog" *ngIf="!remoteUser.additionalInfo.isMessageBoxCollapsed">
          <i class="asd" *ngFor="let message of remoteUser.additionalInfo.messages, let i = index"
             (copy)="utilService.safeCopy($event)"
             (cut)="utilService.safeCut($event)"
             [style]="(message.senderId | userById | isSupportOrObserver) ? 'color: ' + (message.senderId | userById).personalColor +' !important' :
                      (message.senderId | userById | isTeacher) ? 'color: #0c97bf !important' : ''"
             [ngClass]="{'student-message': message.messageType === MessageTypes.TO_STAFF && remoteUser.accessType === AccessType.STUDENT,
                        'teacher-message': message.messageType === MessageTypes.TO_STUDENT || (remoteUser | isStaff),
                        'student-unanswered': remoteUser.accessType === AccessType.STUDENT && remoteUser.additionalInfo.hasUnansweredMessage && i === remoteUser.additionalInfo.messages.length - 1}">
            > {{message.text}}
          </i>
      </span>
      <span class="briefLog" *ngIf="remoteUser.additionalInfo.isMessageBoxCollapsed">
          <i class="asd" *ngFor="let message of remoteUser.additionalInfo.limitedMessages, let i = index"
             (copy)="utilService.safeCopy($event)"
             (cut)="utilService.safeCut($event)"
             [style]="(message.senderId | userById | isSupportOrObserver) ? 'color: ' + (message.senderId | userById).personalColor +' !important' :
                      (message.senderId | userById | isTeacher) ? 'color: #0c97bf !important' : ''"
             [ngClass]="{'student-message': message.messageType === MessageTypes.TO_STAFF && remoteUser.accessType === AccessType.STUDENT,
                        'teacher-message': message.messageType === MessageTypes.TO_STUDENT || (remoteUser | isStaff),
                        'student-unanswered': remoteUser.accessType === AccessType.STUDENT && remoteUser.additionalInfo.hasUnansweredMessage && i === remoteUser.additionalInfo.messages.length - 1}">
            > {{message.text}}
          </i>
      </span>
      <i class="far fa-angle-double-up hide-more-messages ng-scope"
         *ngIf="!remoteUser.additionalInfo.isMessageBoxCollapsed"
         (click)="toggleShowMessages()" title="Collapse chat"></i>
    </div>
  </div>
</div>
